(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StompLogger", [], factory);
	else if(typeof exports === 'object')
		exports["StompLogger"] = factory();
	else
		root["StompLogger"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 